
import { defineComponent } from '@vue/composition-api';
import { FormattedProduct } from '@fc/app-common/src/services/Shopify/types';
import { metaData } from '~/configuration/metaData';
import { CMSService } from '~/services/storyBlok/cmsService';
import ReviewsGrid from '~/components/storyblok/ReviewsGrid/ReviewsGrid.vue';
import PackageAboveTheFold from '~/components/v2/pdps/PackageAboveTheFold.vue';
import FaqSection from '~/components/shop/FaqSection.vue';
import { FCButton } from '@fc/angie-ui';
import storeMutations from '~/store/constants/storeMutations';
import { transformPackageProduct } from '~/utils/transformers';
import packages from '~/data/packages.js';
import { isProdEnvironment } from '~/utils/helpers';

export default defineComponent({
  name: 'FightCampElite',
  head: {
    ...metaData.elite,
    script: [
      {
        src: 'https://static.truemed.com/widgets/product-page-widget.min.js',
        defer: true,
      },
    ],
  },
  components: {
    PackageAboveTheFold,
    ReviewsGrid,
    FaqSection,
    FCButton,
  },
  data() {
    return {
      reviews: [],
      faqs: [],
    };
  },
  mounted() {
    this.$store.commit(storeMutations.SET_MODAL_SUPPRESSION, true);

    if (window.affirm && window.affirm.ui) {
      window.affirm.ui.ready(() => {
        window.affirm.ui.refresh();
      });
    }
  },
  destroyed() {
    this.$store.commit(storeMutations.SET_MODAL_SUPPRESSION, false);
  },
  computed: {
    packageData() {
      return transformPackageProduct({
        cmsContent: packages[2],
        eCommContent: this.$store.getters.productsCollection,
      });
    },
    isCanada() {
      return this.$store.getters.isGeoLocatedCanada;
    },
    pdpUpsells() {
      const isProd = isProdEnvironment();
      const ids = {
        soundSleeve: isProd ? '8531057705196' : '7721843785817',
        warranty: isProd ? '8588387516652' : '7766283747417',
        kidsGloves: isProd ? '4252965601334' : '4252927328345',
        doubleGear: isProd ? '8701921525996' : '7819193745497',
      };

      const firstUpsellId = this.isCanada ? ids.kidsGloves : ids.soundSleeve;

      return [
        { id: `gid://shopify/Product/${firstUpsellId}`, label: 'Most Popular' },
        { id: `gid://shopify/Product/${ids.warranty}`, label: '' },
      ];
    },
    popUpUpsells() {
      // [sound sleeve, warranty, double, jump rope]
      const devItems = ['gid://shopify/Product/7721843785817', 'gid://shopify/Product/7766283747417', 'gid://shopify/Product/7819193745497', 'gid://shopify/Product/7091660062809'];
      const prodItems = ['gid://shopify/Product/8531057705196', 'gid://shopify/Product/8588387516652', 'gid://shopify/Product/8701921525996', 'gid://shopify/Product/7667442450668'];
      const items = isProdEnvironment() ? prodItems : devItems;

      return items.map(id => {
        const prod = this.$store.getters.productsCollection?.find((item: FormattedProduct) => item.id === id);
        return {
          ...prod,
          value: prod?.variants?.[0]?.id,
          cta: 'Add to Cart',
          isDisabled: false,
        };
      });
    },
  },
  methods: {
    scrollToTop() {
      if (process.client) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
    },
  },
  async asyncData({ $storyapi, error }) {
    try {
      const storyBlok = new CMSService({ cmsService: $storyapi });
      const reviews = await storyBlok.getAll('user-reviews');

      const faqs = await storyBlok.get('global/globalpackagefaqs');
      const faqList = faqs?.data?.story?.content?.global?.[0]?.container || [];

      return {
        reviews, faqs: faqList,
      };
    } catch (e: any) {
      error({ message: e.message });
      return {};
    }
  },
});
